import { Component, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AccrualPaidDatePrecedencesModalComponent } from './accrual.paid.date.precedences.modal.component';
import * as _ from 'lodash';

@Component({
    selector: 'accrual-paid-date-precedences-link',
    template: ` <a (click)="launchModal()" class="pointer">Paid Date Precedences</a> `,
    imports: [],
})
export class AccrualPaidDatePrecedencesLinkComponent {
    constructor(private modalService: BsModalService) {}

    @Input() companyId: number;
    @Input() options: any;
    @Input() editMode: boolean;

    launchModal() {
        const initialState = {
            companyId: this.companyId,
            accrualPaidDatePrecedences: _.cloneDeep(this.options.accrualPaidDatePrecedences),
            canEdit: this.editMode,
        };

        const modalRef = this.modalService.show(AccrualPaidDatePrecedencesModalComponent, {
            initialState,
            ignoreBackdropClick: true,
        });

        modalRef.content.onClose = (accrualPaidDatePrecedences: Core.CompanyAccrualPaidDatePrecedenceModel[]) => {
            console.log(accrualPaidDatePrecedences);
            this.options.accrualPaidDatePrecedences = accrualPaidDatePrecedences;
        };
    }
}
